import apiService from '../services/api'
import React, { useMemo } from 'react'
import { Product } from '../models/product'
import { Spinner } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { Modal } from './UI/Modal/Modal'
import { cn } from './UI/cn'

interface ChangeProductViewModalComponentProps {
  show: boolean
  handleClose: () => void
  onSelect: (product: number[]) => void
  selectedProducts: number[]
}

export function ChangeProductViewModal(
  props: ChangeProductViewModalComponentProps
) {
  const api = apiService()
  const { data, isLoading } = api.useProducts()

  const [selectedProducts, setSelectedProducts] = React.useState<number[]>([-1])

  const handleSelect = () => {
    props.onSelect(selectedProducts)
    props.handleClose()
  }

  const products = useMemo(() => {
    if (!data) return []
    return [
      {
        id: -1,
        name: 'All Products',
      } as Product,
      ...data,
    ]
  }, [data])

  return (
    <Modal
      title={'Active Products'}
      description={
        <>
          Find opportunities with revenue and volume estimates calculated for
          all or any of your products. Add or modify products{' '}
          <Link
            style={{
              color: '#087443',
            }}
            to={'/product'}
          >
            here
          </Link>
          .
        </>
      }
      onAccept={handleSelect}
      open={props.show}
      onOpenChange={(open) => !open && props.handleClose()}
      acceptButtonText={'Set Product'}
    >
      {isLoading ? (
        <Spinner animation="border" />
      ) : (
        <div className="deals-modal-table-container">
          <table className="deals-modal-table">
            <thead>
              <tr>
                <th className={'w-[30px]'}></th>
                <th>Product</th>
                <th>Format</th>
              </tr>
            </thead>
            <tbody>
              {products.map((p, i) => {
                return (
                  <tr
                    className={cn({
                      'w-[30px]': i === 0,
                    })}
                    key={p.id}
                    onClick={() => setSelectedProducts([p.id])}
                  >
                    <td>
                      <input
                        type="radio"
                        name="product"
                        value={p.id}
                        onChange={(e) =>
                          setSelectedProducts([parseInt(e.target.value)])
                        }
                        checked={selectedProducts.includes(p.id)}
                      />
                      {/* This is groundwork for multiple product V2 */}
                      {/*<input*/}
                      {/*  type="checkbox"*/}
                      {/*  name="product"*/}
                      {/*  value={p.id}*/}
                      {/*  onChange={(e) => {*/}
                      {/*    if (e.target.checked) {*/}
                      {/*      setSelectedProducts([...selectedProducts, p.id]);*/}
                      {/*    } else {*/}
                      {/*      setSelectedProducts(*/}
                      {/*        [...selectedProducts].filter((x) => x !== p.id)*/}
                      {/*      );*/}
                      {/*    }*/}
                      {/*  }}*/}
                      {/*  checked={selectedProducts.includes(p.id)}*/}
                      {/*/>*/}
                    </td>
                    <td>{p.name ?? '-'}</td>
                    <td>{p.format ?? '-'}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      )}
    </Modal>
  )
}
